/**
 * Created by ivo on 03.02.17.
 */
import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    id: PropTypes.number.isRequired,
    level: PropTypes.string.isRequired,
    title: PropTypes.string,
    message: PropTypes.string.isRequired,
    onHide: PropTypes.func
};

const defaultProps = {
    title: ""
};

class NotifyItem extends React.Component {
    constructor(props) {
        super(props);
        this.hideNotification = this.hideNotification.bind(this);
    }
    hideNotification() {
        if (this.props.onHide) this.props.onHide(this.props.id);
    }

    getTheme(level) {
        switch (level) {
            case 'info':
            case 'success':
            case 'warning':
                return level;
            case 'error':
                return 'danger';
            default:
                return 'info';
        }
    }

    render() {
        return (
            <div className={"alert alert-dismissible alert-" + this.getTheme(this.props.level)} role="alert">
                <button type="button" className="close" onClick={this.hideNotification} aria-label="Close"><span aria-hidden="true">×</span></button>
                <strong>{this.props.title}</strong>
                {this.props.message}
            </div>
        )
    }
}

NotifyItem.propTypes = propTypes;
NotifyItem.defaultProps = defaultProps;

export default NotifyItem;
